module.exports = __webpack_public_path__ + "img/users-solid.7bb67ad6.svg";